// Load all the plugins within this directory and all subdirectories.
// Plugin files must be named *_plugin.js.

const plugins = require.context('.', true, /plugin\.js$/)
plugins.keys().forEach(plugins)
